import { useRemoveCurrency } from '../../states/currencies-state'

interface Props {
  readonly id: string
  readonly name: string
  readonly code: string
  readonly showId: boolean
}

export const CurrencyItem = (props: Props) => {
  const { id, name, code, showId } = props

  const removeCurrency = useRemoveCurrency()

  const handleRemove = () => {
    removeCurrency(id)
  }

  return (
    <tr>
      {showId && <th>{id}</th>}
      <td>{name}</td>
      <td>{code}</td>
      <td className="">
        <button type="submit" className="btn btn-outline btn-warning btn-sm" onClick={handleRemove}>
          Remove
        </button>
      </td>
    </tr>
  )
}